function generateUrlFromImage(baseImage) {
  const link = document.getElementById('achievements-downloader');
  if (!link || !baseImage?.src) return;

  const name = link.dataset.name;
  const image = new Image();
  const color = String(baseImage.dataset.color) || 'transparent';
  image.crossOrigin = 'anonymous';
  image.src = baseImage?.src;
  image.onload = function () {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = baseImage.naturalWidth;
    canvas.height = baseImage.naturalHeight;
    ctx.drawImage(image, 0, 0);
    ctx.font = 'bold 65px Roboto';
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    ctx.fillText(name, canvas.width / 2, canvas.height / 2 + 40);
    link.download = `${name}.jpg`;
    link.href = canvas.toDataURL('image/jpg');
  };
}

function imageGenerate(sliders) {
  if (!sliders) return;
  const mediaQueryList = window.matchMedia('(max-width: 1200px)');
  if (mediaQueryList.matches) {
    generateUrlFromImage(sliders?.[0]?.visibleSlides[0].querySelector('img'));
  } else {
    generateUrlFromImage(sliders?.[1]?.visibleSlides[0].querySelector('img'));
  }

  sliders.forEach((swiper) => {
    swiper.on('slideChange', (slider) => {
      if (slider?.visibleSlides?.[0].querySelector('img')) {
        generateUrlFromImage(slider?.visibleSlides?.[0].querySelector('img'));
      }
    });
  });
}

export default imageGenerate;
